import React from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import './HfTabs.css';
import ImageText from "../ImageText/ImageText";

const HFTab = ({ imageTextData, tabTitles }) => {

  return (
    <div className="text-center">
      <Tabs
        defaultActiveKey={tabTitles[0].eventKey}
        id="uncontrolled-tab-example"
        className="d-inline-flex flex-wrap justify-content-center"
      >
        {tabTitles.map((tab, index) => (
          <Tab key={index} eventKey={tab.eventKey} title={tab.title} className="">
            <div className={`${tab.eventKey}-div`}>
              <ImageText data={imageTextData[index]} />
            </div>
          </Tab>
        ))}
      </Tabs>
    </div>
  );
};

export default HFTab;
